import { z } from 'zod'
import { MetaSchema } from '../calculator'
import { DistributionGroup, TokenDistributionPreview, TokenEmissionPreview } from '../token-designer'

export const PriceDataSchema = z.object({
  date: z.string(),
  value: z.number().safe(),
})

export const TokenInfoResult = z.object({
  coingeckoId: z.string().nullable(),
  coingeckoInfo: z
    .object({
      id: z.string(),
      name: z.string(),
      symbol: z.string(),
      image: z.string(),
    })
    .nullable(),
  maxTokenSupply: z.number().safe(),
  tgeDate: z.string().nullable(),
})

export type TokenInfo = z.infer<typeof TokenInfoResult>

export const TokenDetailsResponse = TokenInfoResult.merge(
  z.object({
    groups: z.array(DistributionGroup),
    distribution: TokenDistributionPreview,
    emissions: TokenEmissionPreview.nullable(),
    ticker: z.string(),
    image: z.string().nullable(),
    daysSinceTGE: z.number().safe(),
    price: z.number().safe(),
    priceChangePercentage24h: z.number().safe(),
    isCoingeckoIdSet: z.boolean(),
    fullyDilutedValuation: z.number().safe(),
    marketChartPrice24h: z.object({
      data: z.array(PriceDataSchema),
      meta: MetaSchema,
    }),
    circulatingTokenSupply: z.number().safe(),
    marketCap: z.number().safe(),
  }),
)

export type TokenDetails = z.infer<typeof TokenDetailsResponse>

export const TokenDetailsToUpdateBody = z.object({
  tgeDate: z.string().date(),
  coingeckoId: z.string().nullable(),
  maxTokenSupply: z.number().safe(),
})

export type TokenDetailsToUpdate = z.infer<typeof TokenDetailsToUpdateBody>
